import { SCREEN_TYPE } from 'consts/enum';

class ENGT_CHAT {
	constructor() {
		const data = {
			config: {},
			unReadMessages: [],
			visibleDatePicker: false,
			notificationCount: 1,
			infocus: false,
			visibleFileUpload: false,
			visibleAutoFill: false,
			selectedDate: '',
			status: {
				current: undefined,
				last: undefined,
				sessionKey: undefined,
			},
			inputMode: 'input',
			speech: {
				allowSpeechRecognition: false,
				allowAudioConversation: false,
				allowContinuousMode: false,
				allowVoiceOutput: false,
				voiceQueue: [],
				audioObj: null,
				audioPlaying: false,
				mediaRecorder: null,
				stream: null,
				transaction_id: null,
				speechRecognizing: false,
				pauseAfterCurrentAudio: false,
				playEmptyAudioForPermission: false,
				nonVoiceTimeout: null,
				MIN_AUDIO_RECORDING_FILE_SIZE: 20000000,
				SILENCE_DELAY: 2000,
				MIN_RECORD_TIME: 4000,
				MAX_RECORD_TIME: 10000,
				MIN_DECIBEL_VALUE: 100,
			},
			fileUploadBaseURL: '',
			mediaIndex: 1,
			quotedMsgDetails: {},
			originalViewportHeight: window.innerHeight,
			lastMessageDetails: {},
			chatHistoryFirstMessageDetails: {},
			temporaryRoomId: null,
			clearTimeoutTypingOff: null,
			shouldNotify: false,
			quotedMsgDetails: null,
			scrollIntoView: null,
			isAllInputsDisabled: false,
			validateFormNode: null,
			editFlowId: '',
			isEditFlowUsed: true,
			ack: 0,
			currentScreen: SCREEN_TYPE.CHAT,
			triggerButtonConfig: {
				isFlowTriggeredFromTriggers: false,
			},
			triggerSessionExpired: false,
			gotUid: false,
			isFaqAcPopUpClose: false,
			isFirstMessage: true,
			manualScrollOnScreens: true,
			isAnalyticsEnabled: false,
			typingAnimationSpeed: 10,
			typingWordsPerInterval: 150,
		};

		if (!ENGT_CHAT.instance) {
			ENGT_CHAT.instance = this;
		}

		this.set = function (key, value) {
			let schema = data;
			const keyList = key.split('.');
			const keyListLength = keyList.length;

			for (let i = 0; i < keyListLength - 1; i++) {
				const elem = keyList[i];
				if (!schema[elem]) schema[elem] = {};
				schema = schema[elem];
			}

			schema[keyList[keyListLength - 1]] = value;

			window.ENGT_CHAT = data;

			return data;
		};

		this.get = function (key) {
			if (!key) return Object.freeze({ ...data });

			let schema = data;
			let index = 0; //
			const keyList = key.split('.');
			let iLen = keyList.length - 1;

			for (index = 0, iLen = keyList.length - 1; index < iLen; index++) {
				const prop = keyList[index];
				const candidate = schema[prop];

				if (candidate !== undefined) {
					schema = candidate;
				} else {
					break;
				}
			}

			try {
				const dataRetrieved = schema[keyList[index]];

				return Array.isArray(dataRetrieved)
					? dataRetrieved
					: typeof dataRetrieved === 'object'
					? Object.freeze({ ...dataRetrieved })
					: dataRetrieved;
			} catch (e) {
				return undefined;
			}
		};

		return ENGT_CHAT.instance;
	}
}

const engtInstance = new ENGT_CHAT();

Object.freeze(engtInstance);

export { engtInstance as ENGT_CHAT };
